import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { JobConstants } from '../../common/utils/job-constants';

@Injectable()
export class AlarmsNotifierService {

    private static aknowledgedAlarmsSubject: Subject<any> = new Subject<any>();
    private static showAlarmsEventSubject: Subject<any> = new Subject<any>();
    private static serviceToSubjectMap: Map<String, Subject<any>> = new Map<String, Subject<any>>();
    private static serviceToAknowledgedAlarmsMap: Map<String, Array<Object>> = new Map<String, Array<Object>>();

    setAlarms(alarms: any): void {
        let alarmsDetail = [];
        alarms.forEach((alarm) => { // todo
            this.addAlarmToServiceAknowledgedAlarmList(alarm);
            alarmsDetail.push(alarm);
        });
        AlarmsNotifierService.serviceToSubjectMap.forEach((value: Subject<any>, key: String) => {
            if ( AlarmsNotifierService.serviceToAknowledgedAlarmsMap.has(key) ) {
                value.next(AlarmsNotifierService.serviceToAknowledgedAlarmsMap.get(key));
            }
        });
        if ( alarmsDetail.length !== 0 ) {
            AlarmsNotifierService.aknowledgedAlarmsSubject.next(alarmsDetail);
        }
        AlarmsNotifierService.serviceToAknowledgedAlarmsMap.clear();
    }

    addAlarmToServiceAknowledgedAlarmList(alarm) {
        if ( AlarmsNotifierService.serviceToAknowledgedAlarmsMap.has(alarm.alarmType) ) {
            AlarmsNotifierService.serviceToAknowledgedAlarmsMap.get(alarm.alarmType).push(alarm);
        } else {
            let processedAlarm = new Array<Object>();
            processedAlarm.push(alarm);
            AlarmsNotifierService.serviceToAknowledgedAlarmsMap.set(alarm.jobType, processedAlarm);
        }
    }

    getAlarms(service: string = 'all'): Observable<any> {
        if ( service === 'all' ) {
            return AlarmsNotifierService.aknowledgedAlarmsSubject.asObservable();
        } else {
            return this.subscribeToNewService(service);
        }
    }

    subscribeToNewService(service: string) {
        AlarmsNotifierService.serviceToSubjectMap.set(service, new Subject<any>());
        return AlarmsNotifierService.serviceToSubjectMap.get(service);
    }

    setShowAlarmsEvent() {
        AlarmsNotifierService.showAlarmsEventSubject.next();
    }

}




// WEBPACK FOOTER //
// ./src/app/services/alarm-notifier.service.ts